<template>
	<base-select-vehicle @close="closeSelectVehicle" :open="openDialog === true">
	</base-select-vehicle>
  <div class="container">
    <div class="card">
      <div class="row">
        <div class="flexbox-container--selected-vehicle--drilldown col-lg-8">
          <div>
            <div class="card-header-catalog">
              <h5 class="card-header-catalog">
                Search for Parts with Currently Selected Vehicle
              </h5>
            </div>
            <div class="card-divider"></div>
            <div
              class="block-space block-space--layout--divider-order-entry"
            ></div>
            <div class="container">
              <div class="flex-container--drilldown-1">
                <div class="vehicles-list__body">
                  <div class="vehicles-list__item-catalog">
                    <div class="vehicles-list__item-info" v-if="selected_year !== 0">
                      <div class="vehicles-list__item-name">
                        {{ selected_year }} {{ selected_make.desc }} {{ selected_model.desc }}
                      </div>
                      <div class="vehicles-list__item-details" v-if="selected_engine != undefined">
                        {{ selected_engine.desc }}
                      </div>
                    </div>
                    <div class="vehicles-list__item-info" v-else>
                      <div class="vehicles-list__item-name">
                        <i>No selected vehicle</i>
                      </div>
                    </div>
                    <div class="product__tags tags tags--sm">
                      <div class="tags__list tags__list-select-vehicle">
                        <button class="mobile-search__vehicle-picker change-vehicle__button" type="button" @click="openSelectVehicle">
                          <span class="search__button-icon">
                            <svg width="20" height="20">
                              <path
                                d="M6.6,2c2,0,4.8,0,6.8,0c1,0,2.9,0.8,3.6,2.2C17.7,5.7,17.9,7,18.4,7C20,7,20,8,20,8v1h-1v7.5c0,0.8-0.7,1.5-1.5,1.5h-1
	c-0.8,0-1.5-0.7-1.5-1.5V16H5v0.5C5,17.3,4.3,18,3.5,18h-1C1.7,18,1,17.3,1,16.5V16V9H0V8c0,0,0.1-1,1.6-1C2.1,7,2.3,5.7,3,4.2
	C3.7,2.8,5.6,2,6.6,2z M13.3,4H6.7c-0.8,0-1.4,0-2,0.7c-0.5,0.6-0.8,1.5-1,2C3.6,7.1,3.5,7.9,3.7,8C4.5,8.4,6.1,9,10,9
	c4,0,5.4-0.6,6.3-1c0.2-0.1,0.2-0.8,0-1.2c-0.2-0.4-0.5-1.5-1-2C14.7,4,14.1,4,13.3,4z M4,10c-0.4-0.3-1.5-0.5-2,0
	c-0.4,0.4-0.4,1.6,0,2c0.5,0.5,4,0.4,4,0C6,11.2,4.5,10.3,4,10z M14,12c0,0.4,3.5,0.5,4,0c0.4-0.4,0.4-1.6,0-2c-0.5-0.5-1.3-0.3-2,0
	C15.5,10.2,14,11.3,14,12z"
                              />
                            </svg>
                          </span>
                          <span class="search__button-title">{{btnVehicleCaption}}</span>
                        </button>
                      </div>
                    </div>

                    <div class="product__tags tags tags--sm">
                      <div class="product__tags tags tags--sm"></div>
                    </div>
                    
                    <div class="flex-container--drilldown-search-parts flex-container--drilldown-partslink-group" id=group-number-search v-if="selected_year !== 0">
                        <input type="text" class="form-control form-control-partslink-group-search" v-model="searchGroupNo"  placeholder="Group Number Search" aria-label="License Plate">
                    </div>
                    <div class="span5" v-if="selected_year !== 0">
                        <div class="flex-container--drilldown-search-parts-button">
                            <button type="button" class="btn btn-sm btn-primary" @click.prevent="searchByGroup()">Search</button>
                        </div>
                    </div>
                  </div>
                  <div class="flex-container--drilldown-search-parts">
                    <input type="text" class="form-control form-control-parts-search" 
                      aria-label="License Plate" v-model="searchText" @keypress.enter="qoSearch()" placeholder="Vehicle Model, Part Number or OE Number" />
                      <p class="vehicles-list__item-details" ><strong>Example:</strong> 2022 Silverado</p>
                  </div>
                  <div class="span5">
                    <div class="flex-container--drilldown-search-parts-button">
                      <button type="button" class="btn btn-lg btn-primary" @click.prevent="qoSearch()">Search</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="block-space block-space--layout--divider-order-entry" ></div>
            <div class="block-space block-space--layout--divider-order-entry" ></div>
          </div>
        </div>
        <div class="col-lg-4">
                        
          <div class="flexbox-container--vehicle-selection-form" v-if="this.userIsAuthenticated">	
            <div>
              <div class="card-header-catalog">
                <h5 class="card-header-catalog">Previously Selected Vehicles</h5>
              </div>
              <div class="card-divider"></div>
              <div class="block-space block-space--layout--divider-order-entry"></div>


              <div class="container">                                                     
                <div class="flex-container--drilldown-2">  
                  <div class="vehicle-form vehicle-form--layout--account">								 

                    <div class="row">
                      <div >
                        <div class="flex-container--drilldown-select-vehicle-inputs">
                          <select class="form-control-select-previous-vehicle form-control form-control-md form-control-select2" @change="updateVehicle($event.target.value)">
                            <option>Choose a Previously Selected Vehicle</option>
                            <option v-for="(vehicle, index) in savedvehicles" :key="index" :value="index">{{ vehicle.year }} {{ vehicle.makedesc }} {{ vehicle.modeldesc }}</option>
                          </select>
                        </div>
                      </div>

                    </div>			   								
                  </div>
                </div>
              </div>
            </div>

          </div>

          <div class="block-space block-space--layout--divider-order-entry"></div>

          <div class="flexbox-container--vehicle-selection-form flexbox-container--vehicle-selection-form-vertical-adj">	
            <div>
              <div class="card-header-catalog">
              <h5 class="card-header-catalog">Parts Interchange Search</h5>
              </div>
              <div class="card-divider"></div>
              <div class="block-space block-space--layout--divider-order-entry"></div>


              <div class="container">                                                     
                <div class="flex-container--drilldown-2">  
                  <div class="vehicle-form vehicle-form--layout--account">								 

                    <div class="row">
                      <div class="span5">
                        <div class="flex-container--drilldown-select-vehicle-inputs">
                          <input type="text" class="form-control form-control-order-entry" v-model="searchPartNo" placeholder="Search by Part Number" aria-label="License Plate">
                        </div>
                      </div>

                      <div class="span5">
                        <div class="flex-container--drilldown-parts-interchange-button">
                          <button type="button" class="btn btn-md btn-primary" @click.prevent="searchByItem()">Search</button>
                        </div>
                      </div>

                    </div>			   								
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VehicleSearch from '../../../mixins/vehicle_search.js';
import { mapGetters } from 'vuex';
import axiosvl from "../../../axios/axios-vl.js";

export default {
    mixins: [ VehicleSearch ],
    data() {
        return {
            searchText: '',
            searchPartNo: '',
            searchGroupNo: '',
            openDialog: false,

            savedvehicles: [],
        }
    },
    computed: {
        ...mapGetters(['storeCatalog', "userIsAuthenticated"]),

        btnVehicleCaption() {
          if(this.selected_year !== 0){
            return "Change Vehicle";
          }else{
            return "Select Vehicle";
          }
        }
    },
    methods: {
        // addToSavedList() {
        //     this.$store.dispatch('vehicle/addToSavedVehicleList');
        // },
        openSelectVehicle() {
          this.openDialog = true;
        },
        closeSelectVehicle() {
          this.openDialog = false;
        },
        qoSearch() {
          if(this.storeCatalog == 'PARTSLINK'){
            this.$router.push("/search-results/keyword/" + this.searchText);
          }else{
            let url = '/keyword-search-results?search=' + this.searchText;
            this.$router.push(url);
          }
        },

        searchByItem() {
          let url = '/search-results/item/' + this.searchPartNo;
          // console.log(url);
          this.$router.push(url);
        },

        searchByGroup() {
          let url = '/search-results/group/' + this.searchGroupNo;
          // console.log(url);
          this.$router.push(url);
        },

        getSavedVehicles() {
            this.savedvehicles = [];
            const catpn = this.$store.getters['storeConfigID'];
            axiosvl.post(this.$store.getters['api/get_saved_vehicle_uri'], {
                "webroutine": {
                "context": {
                    "session-key-method": "hidden"
                },
                "fields": {
                    "EHCUST": {"value": this.$store.getters.customer},
                    "CATPN": {"value": catpn},
                }
                }
            })
            .then((response) => {
                const fields = response.data.webroutine.fields

                if (fields.RESULTCOD.value === 'OK') {
                    const results = [];

                    for (const key in response.data.webroutine.lists.LASTCARSD.entries) {
                        const obj = response.data.webroutine.lists.LASTCARSD.entries[key];
                        results.push({
                            year: obj.QYEAR,
                            make: obj.QMAKE,
                            makedesc: obj.QMKDSC,
                            model: obj.QMODEL,
                            modeldesc: obj.QMODSC,
                            engine: obj.QCARCD,
                            enginedesc: obj.QENDSC,
                        });
                    }
                    this.savedvehicles = results;
                }
            })
            .catch((error) => {
                console.log('error - ' + error);
            });
        },

        updateVehicle(e){
          // console.log(this.savedvehicles[e]);
          let selvehicle = this.savedvehicles[e];
          if (this.$store.getters['storeCatalog'] === 'WHI') {
               
              this.$store.dispatch("vehicle/setSelectedVehicle", { "selectedvehicle": 0 });
              this.$store.dispatch("vehicle/setSelectedYear", { "selectedyear": selvehicle.year });
              this.$store.dispatch("vehicle/setSelectedMake", { "selectedmake": selvehicle.make, "desc": selvehicle.makedesc });
              this.$store.dispatch("vehicle/setSelectedModel", { "selectedmodel": selvehicle.model, "desc": selvehicle.modeldesc });
              this.$store.dispatch("vehicle/setSelectedEngine", { "selectedengine": selvehicle.engine, "desc": selvehicle.enginedesc });
              
          }

          if (this.$store.getters['storeCatalog'] === 'PARTSLINK') {
              this.$store.dispatch("vehicle/setSelectedVehicle", { "selectedvehicle": 0 });
              this.$store.dispatch("vehicle/setSelectedYear", { "selectedyear": selvehicle.year });
              this.$store.dispatch("vehicle/setSelectedMake", { "selectedmake": selvehicle.makedesc, "desc": selvehicle.makedesc });
              this.$store.dispatch("vehicle/setSelectedModel", { "selectedmodel": selvehicle.modeldesc, "desc": selvehicle.modeldesc });
          }

          this.$router.push("/select-parts-drilldown");
        }

    },

    created() {
      this.searchText = '';

      if(this.userIsAuthenticated){
        this.getSavedVehicles();
      }
    }
}
</script>